import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import { API_URL } from "../../common/api/constants";

export const RedirectorRoute: FC = () => {
    const { alias } = useParams() as { alias: string }

    useEffect(() => {
        window.location.replace(`${API_URL}/qr/${alias}`)
    }, [alias])

    return null
}